import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IoIosCalendar } from 'react-icons/io';
import moment from 'moment';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { CaretDown, Eye, PencilSimple } from 'phosphor-react';
import { gerarAmbienteUrl } from '~/Pages/Vendas/helpers';
import { format } from '~/Utils/Helpers';
import { OpenSansMuted, Avatar, Nome, Email, StatusTag, Data } from './styles';

function getInitials(nome) {
  if (!nome) return '';
  return nome
    .split(' ')
    .map(n => n[0])
    .join('')
    .substring(0, 1)
    .toUpperCase();
}

function ProspectoItem({ data, onClick, isActive, modoMobile = false }) {
  const {
    nome,
    contato,
    email,
    descricao_status,
    cor_etapa,
    data_cadastro,
    empreendimento,
    visivel,
    codigo,
    codigo_descriptografado,
  } = data;

  const [toggleDetalhes, setToggleDetalhes] = useState(false);

  return (
    <>
      {!modoMobile && (
        <Row
          className="align-items-center mx-0 mb-2 py-3"
          style={{
            background: '#f8f8f8',
            borderRadius: 8,
            border: isActive ? '1.5px solid #2196f3' : '1px solid #f0f0f0',
            boxShadow: '0 1px 2px rgba(44,62,80,0.04)',
          }}
        >
          <Col xs={1} className="d-flex align-items-center">
            <span
              style={{
                fontFamily: "'Open Sans', sans-serif",
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#3a5ca8',
              }}
            >
              #{codigo_descriptografado}
            </span>
          </Col>
          <Col xs={3} className="d-flex align-items-center">
            <Avatar>{getInitials(nome)}</Avatar>
            <div className="ml-3">
              <Nome style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                {nome}
              </Nome>
              <Email>{email || format.celular(contato)}</Email>
            </div>
          </Col>
          <Col xs={2} className="text-center">
            {descricao_status && (
              <StatusTag
                style={{
                  background: cor_etapa ? cor_etapa : '#ff9800',
                }}
              >
                {descricao_status}
              </StatusTag>
            )}
            {data.interesse_social && (
              <div
                className="d-flex align-items-center justify-content-center mt-1"
                style={{ gap: 4 }}
              >
                <span
                  style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#ff9800',
                  }}
                />
                <span
                  style={{
                    fontSize: '0.65rem',
                    color: '#ff9800',
                    fontWeight: 600,
                  }}
                >
                  Interesse Social
                </span>
              </div>
            )}
          </Col>
          <Col xs={2} className="text-center">
            <Data>
              <IoIosCalendar size={18} />
              {moment(data_cadastro).format('DD/MM/YYYY')}
            </Data>
          </Col>
          <Col xs={2} className="pl-3">
            <OpenSansMuted
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={empreendimento}
            >
              {empreendimento}
            </OpenSansMuted>
          </Col>
          <Col
            xs={2}
            className="d-flex justify-content-center"
            style={{ gap: 16 }}
          >
            <a
              href={`/prospecto/gestao-crm/${codigo}`}
              style={{
                color: '#7bb32e',
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.875rem',
              }}
            >
              <Eye size={14} className="mr-1" />
              Exibir
            </a>
            <a
              href={`/prospectos/lista/${codigo}`}
              style={{
                color: '#ffba1a',
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.875rem',
              }}
            >
              <PencilSimple size={14} className="mr-1" />
              Editar
            </a>
          </Col>
        </Row>
      )}
      {modoMobile && (
        <Card
          className="mb-2"
          style={{
            border: isActive ? '1.5px solid #2196f3' : '1px solid #f0f0f0',
            boxShadow: isActive
              ? '0 0 0 2px #2196f3'
              : '0 1px 2px rgba(44,62,80,0.04)',
          }}
        >
          <Card.Body className="p-3">
            <div className="d-flex align-items-center">
              <Avatar className="mr-3">{getInitials(nome)}</Avatar>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Nome className="font-weight-bold">{nome}</Nome>
                <Email>#{codigo}</Email>
                <Email>{email || format.celular(contato)}</Email>
              </div>
              {descricao_status && (
                <StatusTag
                  className="ml-2"
                  style={{
                    background: cor_etapa ? cor_etapa : '#ff9800',
                    fontSize: '0.6rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {descricao_status}
                </StatusTag>
              )}
              {data.interesse_social && (
                <span
                  className="ml-1"
                  style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#ff9800',
                  }}
                  title="Interesse Social"
                />
              )}
              <button
                onClick={() => setToggleDetalhes(v => !v)}
                className="btn btn-link p-0 ml-2"
                style={{ border: 'none' }}
                aria-label={
                  toggleDetalhes ? 'Ocultar detalhes' : 'Exibir detalhes'
                }
              >
                <CaretDown
                  size={22}
                  style={{
                    transform: toggleDetalhes
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                    color: '#293c66',
                  }}
                />
              </button>
            </div>

            {toggleDetalhes && (
              <>
                <hr className="my-3" />
                <Row>
                  <Col xs={6}>
                    <OpenSansMuted className="small mb-1">
                      Data de negociação
                    </OpenSansMuted>
                    <Data style={{ color: '#293c66' }}>
                      <IoIosCalendar size={18} />
                      {moment(data_cadastro).format('DD/MM/YYYY')}
                    </Data>
                  </Col>
                  <Col xs={6}>
                    <OpenSansMuted className="small mb-1">
                      Empreendimento
                    </OpenSansMuted>
                    <div
                      className="font-weight-bold text-truncate"
                      style={{ color: '#3a5ca8' }}
                      title={empreendimento}
                    >
                      {empreendimento}
                    </div>
                  </Col>
                </Row>
                <div
                  className="d-flex justify-content-end mt-3"
                  style={{ gap: 8 }}
                >
                  <Button
                    href={`/prospecto/gestao-crm/${codigo}`}
                    size="sm"
                    style={{
                      background: '#7BB32E',
                      borderColor: '#7BB32E',
                      borderRadius: 8,
                    }}
                  >
                    <Eye size={16} color="#fff" />
                  </Button>
                  <Button
                    href={`/prospectos/lista/${codigo}`}
                    size="sm"
                    style={{
                      background: '#FFBA1A',
                      borderColor: '#FFBA1A',
                      borderRadius: 8,
                    }}
                  >
                    <PencilSimple size={16} color="#fff" />
                  </Button>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
}

ProspectoItem.propTypes = {
  data: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    email: PropTypes.string,
    contato: PropTypes.string,
    descricao_status: PropTypes.string,
    cor_etapa: PropTypes.string,
    data_cadastro: PropTypes.string,
    empreendimento: PropTypes.string,
    visivel: PropTypes.bool,
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
};

export default ProspectoItem;
